import { useEffect } from 'react';
import { Alert, tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { useCurrentSite } from '@hotjar/site';
import { useTrackingCode } from '@hotjar/webapp/hooks/useTrackingCode';
import { tagRecording } from '@hotjar/webapp/tracking/tools/hotjar';
import { useModalTrackingCode } from '@hotjar/webapp/hooks/useModalTrackingCode';

const Wrapper = styled.div<{ noSidePadding: boolean | undefined }>`
  padding: ${tokens.spacer.x4} ${({ noSidePadding }) => (noSidePadding ? 0 : tokens.spacer.x4)} 0;
`;

export interface TrackingCodeNudgeProps {
  toolName: string;
  noSidePadding?: boolean;
}

export const TrackingCodeNudge = ({
  toolName,
  noSidePadding,
}: TrackingCodeNudgeProps): JSX.Element | null => {
  const { t } = useTranslation();
  const { data: currentSite } = useCurrentSite();
  const { getState } = useTrackingCode();
  const { show: openTrackingCodeModal } = useModalTrackingCode();
  const trackingCodeState = getState(currentSite?.lastData);

  const handleOnClick = () => {
    tagRecording('TC Nudge: Clicked');
    if (currentSite) {
      openTrackingCodeModal(currentSite, 1, 'Tracking Code Nudge');
    }
  };

  useEffect(() => {
    if (currentSite?.id && !trackingCodeState.installed) {
      tagRecording('TC Nudge: Visible');
    }
  }, [currentSite?.id, trackingCodeState?.installed]);

  if (trackingCodeState.installed && currentSite?.id) {
    return null;
  }

  return (
    <Wrapper noSidePadding={noSidePadding}>
      <Alert
        style={{ width: '100%', maxWidth: '100%' }}
        kind="info"
        title={t('activation:tracking-code.nudge.title', { toolName })}
        actionText={t('activation:tracking-code.nudge.cta')}
        onAction={handleOnClick}
      >
        {t('activation:tracking-code.nudge.text')}
      </Alert>
    </Wrapper>
  );
};
